import type { ApiErrorMessage } from 'epic/apiErrorEpicHelper';
import type { NextWorkflowError } from 'models/NextWorkflowError';

import * as actionTypes from './dynamicForm.actionTypes';
export type DynamicFormAction = BookingActions;
export type BookingActions =
  | DynamicBookingRequested
  | DynamicBookingRequestFailed
  | DynamicBookingAcked
  | DynamicAllBookingResultsReceived
  | DynamicBookingQuoteFailed
  | DynamicBookingTradeDone
  | DynamicBookingTradeRejected
  | DynamicBookingTradeAuthFailed;

export function dynamicBookingRequested(
  tabId: string,
  withExecution: boolean,
  frontReconciliationId: string,
  quoteId: string,
) {
  return {
    type: actionTypes.DYNAMIC_BOOKING_REQUESTED,
    tabId,
    withExecution,
    frontReconciliationId,
    quoteId,
  };
}
export type DynamicBookingRequested = ReturnType<typeof dynamicBookingRequested>;

export function dynamicBookingAcked(
  tabId: string,
  negotiationId: string,
  quoteId: string,
  quoteExternalId: string,
  withExecution: boolean,
  frontReconciliationId: string,
) {
  return {
    type: actionTypes.DYNAMIC_BOOKING_ACKED,
    tabId,
    negotiationId,
    quoteId,
    quoteExternalId,
    withExecution,
    frontReconciliationId,
  };
}
export type DynamicBookingAcked = ReturnType<typeof dynamicBookingAcked>;

export function dynamicBookingRequestFailed(
  tabId: string,
  technicalError: ApiErrorMessage,
  frontReconciliationId: string,
) {
  return {
    type: actionTypes.DYNAMIC_BOOKING_REQUEST_FAILED,
    tabId,
    technicalError,
    frontReconciliationId,
  };
}

export type DynamicBookingRequestFailed = ReturnType<typeof dynamicBookingRequestFailed>;

export function dynamicAllBookingResultsReceived(quoteId: string, tabId: string) {
  return {
    type: actionTypes.DYNAMIC_ALL_BOOKING_RESULTS_RECEIVED,
    quoteId,
    tabId,
  };
}

export type DynamicAllBookingResultsReceived = ReturnType<typeof dynamicAllBookingResultsReceived>;

export function dynamicBookingTradeDone(
  tabId: string,
  quoteId: string,
  status: string,
  when: Date,
  rejections?: readonly NextWorkflowError[],
) {
  return {
    type: actionTypes.DYNAMIC_BOOKING_TRADE_DONE,
    tabId,
    quoteId,
    status,
    when,
    rejections,
  };
}

export type DynamicBookingTradeDone = ReturnType<typeof dynamicBookingTradeDone>;

export function dynamicBookingTradeRejected(
  tabId: string,
  quoteId: string,
  rejections: readonly NextWorkflowError[],
  when: Date,
) {
  return {
    type: actionTypes.DYNAMIC_BOOKING_TRADE_REJECTED,
    tabId,
    quoteId,
    rejections,
    when,
  };
}

export type DynamicBookingTradeRejected = ReturnType<typeof dynamicBookingTradeRejected>;

export function dynamicBookingQuoteFailed(tabId: string, quoteId: string) {
  return {
    type: actionTypes.DYNAMIC_BOOKING_QUOTE_FAILED,
    tabId,
    quoteId,
  };
}

export type DynamicBookingQuoteFailed = ReturnType<typeof dynamicBookingQuoteFailed>;

export function dynamicBookingTradeAuthFailed(tabId: string, quoteId: string) {
  return {
    type: actionTypes.DYNAMIC_BOOKING_TRADE_AUTH_FAILED,
    tabId,
    quoteId,
  };
}

export type DynamicBookingTradeAuthFailed = ReturnType<typeof dynamicBookingTradeAuthFailed>;
